module.exports = __webpack_public_path__ + "img/viewpoint-animate3.d983b8d5.png";